import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CalculoService {
  constructor(private $$shttp: SuperHttpClientProvider) {}

  private get $shttp() {
    return this.$$shttp.use('backoffice');
  }

  public realizarCalculo<T = any>(idModulo: number, data: any): Observable<T> {
    const url = `/module/statistics/${idModulo}`;
    return this.$shttp.post<T>(url, data);
  }
}
